import { FormattedMessage } from 'react-intl';

import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';

import { U23EligibleIcon } from './U23EligibleIcon/index.tsx';

type Props = {
  until?: Date | null;
};

export const U23Eligible = ({ until }: Props) => {
  return (
    <Tooltip
      title={
        <>
          <div>
            <strong>
              <FormattedMessage defaultMessage="U23 Eligible" />
            </strong>
          </div>
          {!!until && (
            <div>
              <FormattedMessage
                defaultMessage="Until {until, date, long}"
                values={{ until }}
              />
            </div>
          )}
        </>
      }
    >
      <U23EligibleIcon />
    </Tooltip>
  );
};
